/**
 * PATH: apps/hr/src/pages/settings/DocumentTypeManagementPage.tsx
 * PURPOSE: HR document type settings (real-data only)
 *
 * WHY:
 * - The previous implementation used mock document types.
 * - Document/OCR configuration is not yet backed by a real HR API in this hub.
 */

import { FileText } from 'lucide-react'
import { EmptyState } from '../../components/ui/EmptyState'

export function DocumentTypeManagementPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">Document Types</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
          Configure document types and OCR behaviour.
        </p>
      </div>

      <EmptyState
        icon={FileText}
        title="Document types not connected"
        description="This page has been cleaned up to remove dummy data. Once a documents/OCR settings API is available for HR Hub, configuration will appear here."
      />
    </div>
  )
}

export default DocumentTypeManagementPage

